import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<
  void,
  'inputRoot' | 'disabled' | 'checked' | 'error' | 'itemRoot'
>()(({ breakpoints, tokens }, _, classes) => ({
  root: {
    gap: tokens.spacing['8'],

    [breakpoints.up('md')]: {
      gap: tokens.spacing['24'],
    },
  },

  groupMargin: {
    marginBottom: tokens.spacing['24'],
  },

  withoutMargins: {
    margin: 0,
  },

  itemRoot: {
    alignItems: 'flex-start',
    margin: 0,

    [`& .${classes.inputRoot}`]: {
      position: 'relative',

      '&::after': {
        position: 'absolute',
        top: tokens.spacing['2'],
        left: tokens.spacing['4'],
        display: 'block',
        width: 20,
        height: 20,
        backgroundColor: tokens.colors.bg.light.primary,
        borderRadius: '50%',
        content: "''",
      },
    },

    '& .vkuiIcon': {
      zIndex: 1,
    },

    [`&:hover:not(.${classes.disabled})`]: {
      '& .vkuiIcon path': {
        fill: tokens.colors.original.brand.primary,
      },

      [`&& .${classes.checked} .vkuiIcon path`]: {
        fill: tokens.colors.original.brand.tertirary,
      },
    },

    [`&:not(.${classes.disabled}) .${classes.inputRoot}.${classes.checked} .vkuiIcon path`]:
      {
        fill: tokens.colors.original.brand.primary,
      },

    [`&.${classes.disabled} .${classes.inputRoot}::after`]: {
      top: tokens.spacing['2'],
      left: tokens.spacing['4'],
      width: 20,
      height: 20,
      backgroundColor: tokens.colors.bg.greyscale.primary,
    },

    [`&.${classes.disabled} .${classes.inputRoot}.${classes.checked} .vkuiIcon`]:
      {
        '&:first-of-type path': {
          fill: 'transparent',
        },

        '&:last-of-type path': {
          fill: tokens.colors.stroke.secondary,
        },
      },
  },

  inputRoot: {
    paddingTop: 0,
    paddingRight: tokens.spacing['2'],
    paddingBottom: 0,
    paddingLeft: tokens.spacing['2'],

    [`&:hover, &:hover.${classes.checked}`]: {
      backgroundColor: 'transparent',
    },

    '& .vkuiIcon path': {
      fill: tokens.colors.stroke.primary,
    },
  },

  label: {
    marginTop: tokens.spacing['2'],
  },

  labelTop: {
    alignItems: 'center',
    gap: tokens.spacing['10'],
  },

  labelTopRow: {
    [breakpoints.up('md')]: {
      gap: tokens.spacing['12'],
    },

    [breakpoints.up('lg')]: {
      gap: tokens.spacing['32'],
    },

    flexWrap: 'nowrap',
  },

  checked: {},

  disabled: {},

  error: {
    [`&& .${classes.itemRoot} .${classes.inputRoot}.${classes.checked} .vkuiIcon path`]:
      {
        fill: tokens.colors.accent.text.error,
      },

    [`&& .${classes.itemRoot}:hover:not(.${classes.disabled}) .${classes.inputRoot}:not(.${classes.checked}) .vkuiIcon path`]:
      {
        fill: tokens.colors.stroke.primary,
      },

    [`&& .${classes.itemRoot}:hover:not(.${classes.disabled}) .${classes.inputRoot}.${classes.checked} .vkuiIcon path`]:
      {
        fill: tokens.colors.accent.text.error,
      },
  },
}));
